module.exports = __webpack_public_path__ + "static/img/logo18.8b959ec2.png";